import type { AbortUploadDetail } from 'shared/domain/messages/httpQueue/eventMessages';
import { swSignals } from 'serviceWorker/events/swSignals';

/** Drops the queued upload of a file (served on the HTTP queue channel). */
export const abortUpload = ({ localId, type }: AbortUploadDetail): void => {
  swSignals.uploadAborted.emit({ localId, type });
};
